// @ts-expect-error
import Bacon from 'baconjs';
import * as ramda from 'ramda';

import {api} from 'nutshell-core/api';

// @ts-expect-error
function fetchSchema(baseUrl) {
    // @ts-expect-error
    return api.get(`${baseUrl}/fields`).then((res) => res.json());
}

// @ts-expect-error
function defaultMaxMerge(entityType) {
    return entityType === 'leads' ? 3 : 50;
}

/**
 * Factory function for stateful stream that will contain the schema for a
 * given type of entity.
 *
 * @param  {string} baseUrl - Url for the schema being requested
 * @param  {Dispatcher} dispatcher - dispatcher from parent context
 * @param  {string} entityType - the type of entity we are requeting data for
 * @return {Bacon.Property} - Stateful stream containing the schema for a given
 *                            entityType.
 */
export default function (baseUrl: string, dispatcher: any, entityType: string) {
    const {push, stream} = dispatcher;

    const schemaResponses = stream('initialize')
        .merge(stream('SCHEMA-FETCH'))
        .flatMap(() => Bacon.fromPromise(fetchSchema(baseUrl)));

    const maxMergeCount = Bacon.update(
        defaultMaxMerge(entityType),
        // @ts-expect-error
        [schemaResponses.filter(({maxMergeCount: mmc}) => ramda.identity(mmc))],
        // @ts-expect-error
        (unused, {maxMergeCount: mmc}) => mmc
    );

    // @ts-expect-error
    const propertyMap = Bacon.update({}, [schemaResponses], (unused, {properties}) =>
        ramda.mapObjIndexed((prop, name) => {
            // @ts-expect-error
            prop.name = name;

            return prop;
        }, properties)
    );

    // @ts-expect-error
    const properties = Bacon.update([], [propertyMap.changes()], (unused, props) =>
        ramda.values(props)
    );

    return Bacon.combineTemplate({
        maxMergeCount,
        properties,
        propertyMap,

        refresh() {
            push('SCHEMA-FETCH');
        },
    });
}
